import type { ReactNode } from 'react';

/**
 * Small status chip, ported from the creator-portal prototype (ROU-1192). The
 * `status` maps to a `.status-pill--<status>` colour and a default label; pass
 * `children` to override the label.
 */

const LABELS: Record<string, string> = {
    active: 'Accepted',
    invited: 'Invited',
    closed: 'Closed',
    completed: 'Completed',
    declined: 'Declined',
    paid: 'Complete',
    review: 'In review',
    rejected: 'Changes needed',
    approved: 'Approved',
};

type Props = {
    status: string;
    children?: ReactNode;
};

const StatusPill = ({ status, children }: Props) => {
    return <span className={`status-pill status-pill--${status}`}>{children || LABELS[status] || status}</span>;
};

export default StatusPill;
